import classNames from 'classnames';
import React, { useState, useMemo, useCallback } from 'react';
import { useClickOutside } from '../../../hooks/useClickOutside';
import MyCheckbox from '../../elements/checkbox/Checkbox';
import { ReactComponent as DownArrow } from './../downArrow.svg';
import { ReactComponent as SearchIcon } from './../secondPage/searchIcon.svg';
import { ReactComponent as AddEmail } from './addEmail.svg';

import './FormSelectSearchField.css';

const FormSelectSearchField = ({
    name,
    searchHeader,
    header,
    headerWithSearch,
    list,
    values,
    setValues,
    isFullWidth,
}) => {
    const [selectIsOpen, setSelectIsOpen] = useState(false);
    const [searchField, setSearchField] = useState('');

    let domNode = useClickOutside(() => {
        setSelectIsOpen(false);
    });

    const addItem = item => {
        const isExist = !!values[name].filter(value => value.uid === item.uid).length;
        let updateValue;
        updateValue = !isExist
            ? [...values[name], { ...item }]
            : [...values[name]].filter(listItem => item.uid !== listItem.uid);
        setValues(prevValues => ({
            ...prevValues,
            [name]: updateValue,
        }));
    };

    const filteredItems = useMemo(
        () =>
            list.filter(item => {
                if (name === 'invitedTeams' || name === 'teams') {
                    return (
                        item?.name &&
                        item?.name?.toLowerCase().includes(searchField.toLowerCase().trim())
                    );
                } else if (name === 'invitedIndividuals') {
                    return (
                        item?.name?.toLowerCase().includes(searchField.toLowerCase().trim()) ||
                        item?.email?.toLowerCase().includes(searchField.toLowerCase().trim())
                    );
                }
            }),
        [list, searchField]
    );

    const renderDropDownList = () => {
        return filteredItems.map(item => {
            const isExist = !!values[name].filter(value => value.uid === item.uid).length;
            return (
                <li key={item.uid} className="dropDown__listItem" onClick={() => addItem(item)}>
                    <div className="dropDown__listItem-text-wrap">
                        <span className="dropDown__listItem-name">{item.name || item.email}</span>
                        {name === 'invitedIndividuals' ? (
                            <span className="dropDown__listItem-email">{item.email}</span>
                        ) : null}
                    </div>
                    <MyCheckbox
                        isExist={isExist}
                        name={name}
                        item={item}
                        values={values}
                        setValues={setValues}
                    />
                </li>
            );
        });
    };

    const dropDownItems = useMemo(() => renderDropDownList(list), [filteredItems, values[name]]);

    const handleSearch = useCallback(
        e => {
            setSearchField(e.target.value);
        },
        [searchField]
    );

    const handleToggle = useCallback(() => {
        setSelectIsOpen(!selectIsOpen);
        setSearchField('');
    }, [selectIsOpen, searchField]);

    const addUnregisteredUser = useCallback(() => {
        addItem({
            name: '',
            firstName: '',
            lastName: '',
            email: searchField.trim(),
            uid: searchField.trim(),
        });
    }, [addItem, searchField]);

    const dropDownContainerClass = classNames({
        dropDownContainer: true,
        isFullWidth: isFullWidth,
        'mask-disable': values.isPublicPost,
    });

    const addEmailClass = classNames({
        addEmail: true,
        remove: !!values[name].filter(item => item.email === searchField).length,
    });

    return (
        <div className={dropDownContainerClass} ref={domNode}>
            <div className="dropDown__header" onClick={handleToggle}>
                <div className={`headerContainer ${selectIsOpen ? 'openHeaderContainer' : ''}`}>
                    {selectIsOpen ? (
                        <>
                            <div className="headerTitle small">{headerWithSearch}</div>
                            <input
                                onClick={e => e.stopPropagation()}
                                autoFocus
                                placeholder={searchHeader}
                                onChange={handleSearch}
                                value={searchField}
                            />
                        </>
                    ) : (
                        <div className="headerTitle big">{header}</div>
                    )}
                </div>
                {selectIsOpen &&
                !!searchField.length &&
                !dropDownItems.length &&
                name === 'invitedIndividuals' ? (
                    <span onClick={addUnregisteredUser}>
                        <AddEmail className={addEmailClass} />
                    </span>
                ) : (
                    <DownArrow />
                )}
            </div>
            {selectIsOpen && (
                <div className="dropDown__listContainer dropDown-search__listContainer">
                    {dropDownItems.length ? (
                        <ul className="dropDown__list">{dropDownItems}</ul>
                    ) : (
                        <span className="no-results">
                            {name === 'invitedTeams' || name === 'teams'
                                ? "We couldn't find team"
                                : 'We couldn`t find user'}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default FormSelectSearchField;
